import { useEffect, useState } from "react";

const maxTimeoutMs = 2_147_483_647;

/** Re-read the current time at the deadline, without overflowing browser timers. */
export function useNowAt(at: number | undefined): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (at === undefined || now >= at) {
      return;
    }
    const timeout = setTimeout(
      () => setNow(Date.now()),
      Math.min(maxTimeoutMs, Math.max(0, at - Date.now())),
    );
    return () => clearTimeout(timeout);
  }, [at, now]);
  return now;
}
